function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 25
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "a",
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 25,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3297.322 6697.605)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.378,26.332v1.062a.877.877,0,0,1-.877.877H5.131a.877.877,0,0,1-.877-.877V17.77H17.64l2.423-2.839A2.647,2.647,0,0,0,17.5,12.9H5.131A2.625,2.625,0,0,0,2.5,15.508V27.393a2.63,2.63,0,0,0,2.631,2.631H17.5a2.645,2.645,0,0,0,2.631-2.631V24.624l-.623.715A4.171,4.171,0,0,1,18.378,26.332Zm-8.17-11.793a.793.793,0,0,1,.785.785.785.785,0,1,1-1.569,0A.809.809,0,0,1,10.208,14.539Zm-2.354,0a.793.793,0,0,1,.785.785.785.785,0,1,1-1.569,0A.793.793,0,0,1,7.854,14.539Zm-2.377,0a.793.793,0,0,1,.785.785.785.785,0,1,1-1.569,0A.793.793,0,0,1,5.477,14.539Z",
  transform: "translate(-3297.5 -6706.9)",
  fill: "#bdbdbd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.508,45.739l.808-.946a1.086,1.086,0,0,0-.369-.092h-7.57a.877.877,0,0,0,0,1.754h6.67A2.542,2.542,0,0,1,28.508,45.739Z",
  transform: "translate(-3311.346 -6731.36)",
  fill: "#bdbdbd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.5,61.977a.877.877,0,0,0,.877.877h5.608a1.505,1.505,0,0,1,.046-.554l.3-1.2H21.377A.877.877,0,0,0,20.5,61.977Z",
  transform: "translate(-3311.346 -6743.977)",
  fill: "#bdbdbd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.751,58.123l1.892-.808a3.661,3.661,0,0,0,.992-.692L56.121,54.5a3.118,3.118,0,0,0-.508,1.085l-.485,1.985A.453.453,0,0,0,55.751,58.123Z",
  transform: "translate(-3337.966 -6738.899)",
  fill: "#bdbdbd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.978,23.149l-.946-.808a1.06,1.06,0,0,0-1.5.115L63.5,28.411l2.585,2.169,5.031-5.931A1.083,1.083,0,0,0,70.978,23.149Z",
  transform: "translate(-3344.422 -6713.964)",
  fill: "#bdbdbd"
})));

var SvgBlog = function SvgBlog(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blog.4169587b.svg";
export { ForwardRef as ReactComponent };